import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-7edc9e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-center full-width q-mt-xl" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "header-list"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Produtor", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Município", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Talhão", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Área", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Data da recomendação", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Colaborador", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cultura", -1))
const _hoisted_15 = {
  key: 0,
  class: "diagnostico-analise"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titulo-azul" }, "Diagnóstico da análise do solo", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "data-item" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "data-item-text data-item-value" }, " legendas: ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "data-item" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "data-item-text data-item-value alto" }, " alto ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "data-item" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "data-item-text data-item-value adequado" }, " adequado ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "data-item" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "data-item-text data-item-value medio" }, " médio ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "data-item" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "data-item-text data-item-value baixo" }, " baixo ")
  ])
], -1))
const _hoisted_18 = { class: "data" }
const _hoisted_19 = { class: "data-item-text" }
const _hoisted_20 = {
  key: 1,
  class: "antes-correcao"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titulo-azul" }, "Antes da correção", -1))
const _hoisted_22 = { class: "data" }
const _hoisted_23 = { class: "data-item-text" }
const _hoisted_24 = {
  key: 2,
  class: "pos-correcao"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titulo-azul" }, "Pós correção", -1))
const _hoisted_26 = { class: "data" }
const _hoisted_27 = { class: "data-item-text" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "html2pdf__page-break" }, null, -1))
const _hoisted_29 = { class: "recomendacao-fosfatagem" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titulo-azul" }, "Fosfatagem", -1))
const _hoisted_31 = { class: "recomendacao-potassagem" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titulo-azul" }, "Potassagem", -1))
const _hoisted_33 = { class: "recomendacao-correcao" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titulo-azul" }, "Recomendação de correção do solo", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Calagem", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Complementação de Enxofre", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Necessidade de suprir Enxofre: ", -1))
const _hoisted_38 = { class: "recomendacao-adubacao" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titulo-azul" }, "Recomendação de adubação", -1))
const _hoisted_40 = { class: "title-applied" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fertilizante: ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Dose: ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Forma de aplicação:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "html2pdf__page-break" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Micronutrientes", -1))
const _hoisted_47 = { class: "graph" }
const _hoisted_48 = {
  key: 3,
  class: "full-width text-center"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nutrientes", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Extração da Cultura", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Exportação da Cultura", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Teores Extraídos do Solo", -1))
const _hoisted_53 = { class: "recomendations-line" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Recomendação Nutricional", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "NORTOX Aplicado", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Saldo - deve ser zerado", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "html2pdf__page-break" }, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Macronutrientes", -1))
const _hoisted_59 = { class: "graph" }
const _hoisted_60 = { class: "full-width text-center" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nutrientes", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Extração da Cultura", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Exportação da Cultura", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Teores Extraídos do Solo", -1))
const _hoisted_65 = { class: "recomendations-line" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Recomendação Nutricional", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "NORTOX Aplicado", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Saldo - deve ser zerado", -1))

import { api } from '@/utils';
import { ref, onMounted } from 'vue';
import { ReportAnalysisItem } from '@/models/report-analysis-item';
import { Substance } from '@/models/substance';
import store from '@/store';
import { useRoute } from 'vue-router';
import Vue3Html2pdf from 'vue3-html2pdf';
import useQuasar from 'quasar/src/composables/use-quasar.js';;

interface SubstanceValue {
  substanceCode: string;
  value: number | string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const quasar = useQuasar();
const html2Pdf = ref(null)
let helper = ref(null)
let reportInfo = ref(null)

onMounted(() => {
  helper = html2Pdf
})

quasar.loading.show();

function printDocument() {   
  helper.value.generatePdf()
}

let optionsPDF = {
  margin: 10,
  filename: "reportRecomendations.pdf"
}

const route = useRoute();

const reportAnalysisItems = ref<ReportAnalysisItem[]>([]);
const substances = ref<Substance[]>([]);

let diagnosticoID = [8, 10, 31, 15, 16, 13, 40, 41, 42, 43, 44] //usar o 14?
let antesCorrecaoID = [29, 30, 31, 28, 33]
let posCorrecaoID = [64, 65, 66, 37]
let recomendacaoSoloCalagemID = [55, 45, 46, 47, 38]
let recomendacaoSoloEnxofreID = [61]
let fosfatagem = [59, 139, 84]
let potassagem = [52]

let optionsMicro = {
  chart: {
    type: 'bar',
  },
  xaxis: {
    categories: store.state.dataResults.microSubstancesString,
  },
  title: {
    text: 'Saldo',
    floating: true,
    align: 'center',
  },
};

let seriesMicro = [
  {
    name: 'saldo',
    data: store.state.dataResults.microBalance,
  },
];

let optionsMacro = {
  chart: {
    type: 'bar',
  },
  xaxis: {
    categories: store.state.dataResults.macroSubstancesString,
  },
  title: {
    text: 'Saldo',
    floating: true,
    align: 'center',
  },
};

let seriesMacro = [
  {
    name: 'saldo',
    data: store.state.dataResults.macroBalance,
  },
];

api
  .get(`report/${route.params.id}`)
  .then((response) => {
    reportInfo.value = response.data;
    quasar.loading.hide();
  })
  .catch((error) => {
    console.log('Erro ao obter dados do relatório.', error.response);
  });


function getItemFromAnalysis(id){
  const value =
      store.state.dataRecomendations.reportAnalysisItems.find((reportAnalysisItem) => {
        
        return reportAnalysisItem.analysisItemId === id;
      })
  
  
  return value;
}

function getClassBackground(substanceID){

  const extractorP =
    store.state.dataRecomendations.reportAnalysisItems.find((reportAnalysisItem) => {
      
      return reportAnalysisItem.analysisItemId === 9;
    })

  const extractor =
    store.state.dataRecomendations.reportAnalysisItems.find((reportAnalysisItem) => {
      
      return reportAnalysisItem.analysisItemId === 39;
    })
  
  const substance =
    store.state.dataRecomendations.reportAnalysisItems.find((reportAnalysisItem) => {
      
      return reportAnalysisItem.analysisItemId === substanceID;
    })

  let classe = "teste";
  let aux = [40, 41, 42, 43, 44].find((id) => {return id == substanceID});

  if(aux){
    if(extractor.value == 'Mehlich-1') {
      switch (substanceID) {
        case 43: // Cu
          if(parseFloat(substance.value) < 0.5){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 0.8){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 10){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        case 42: //Mn
          if(parseFloat(substance.value) < 5){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 10){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 30){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        case 44: //Zn
          if(parseFloat(substance.value) < 0.6){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 4.9){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 10){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        case 41: //Fe
          if(parseFloat(substance.value) < 19){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 30){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 45){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        case 40: //B
          if(parseFloat(substance.value) < 0.5){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 0.6){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 1){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        default:
          console.log(`Sorry, we are out of ${substanceID}.`);
      }
    } 
    else {

      switch (substanceID) {
        case 43: // Cu
          if(parseFloat(substance.value) < 0.15){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 0.33){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 7){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        case 42: //Mn
          if(parseFloat(substance.value) < 1){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 1.9){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 10){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        case 44: //Zn
          if(parseFloat(substance.value) < 0.3){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 3){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 10){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        case 41: //Fe
          if(parseFloat(substance.value) < 5){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 12){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 30){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        case 40: //B
          if(parseFloat(substance.value) < 0.5){
            classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 0.6){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 1){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }

          break;
        default:
          console.log(`Sorry, we are out of ${substanceID}.`);
      }
    }
  }

  if(substanceID == 10){
    if(extractorP.value == 'Mehlich-1') {

      const argila =
        store.state.dataRecomendations.reportAnalysisItems.find((reportAnalysisItem) => {
        return reportAnalysisItem.analysisItemId === 6;
      })

      if(parseFloat(argila.value) < 16){
        if(parseFloat(substance.value) < 12){
              classe = "baixo"
        } 
        else {
          if(parseFloat(substance.value) < 18){
            classe = "medio"
          } 
          else {
            if(parseFloat(substance.value) < 25){
              classe = "adequado"
            } 
            else {
                classe = "alto"
            }
          }
        }
      } 
      else {
        if(parseFloat(argila.value) < 35){
          if(parseFloat(substance.value) < 10){
                classe = "baixo"
          } 
          else {
            if(parseFloat(substance.value) < 15){
              classe = "medio"
            } 
            else {
              if(parseFloat(substance.value) < 20){
                classe = "adequado"
              } 
              else {
                  classe = "alto"
              }
            }
          }
        } 
        else {
          if(parseFloat(argila.value) < 60){
            if(parseFloat(substance.value) < 5){
                  classe = "baixo"
            } 
            else {
              if(parseFloat(substance.value) < 8){
                classe = "medio"
              } 
              else {
                if(parseFloat(substance.value) < 12){
                  classe = "adequado"
                } 
                else {
                    classe = "alto"
                }
              }
            }
          } 
          else {
              if(parseFloat(substance.value) < 3){
                    classe = "baixo"
              } 
              else {
                if(parseFloat(substance.value) < 4){
                  classe = "medio"
                } 
                else {
                  if(parseFloat(substance.value) < 6){
                    classe = "adequado"
                  } 
                  else {
                      classe = "alto"
                  }
                }
              }
          }
        }
      }
    }
  else { // extrator = Resina
    if(parseFloat(substance.value) < 10){
          classe = "baixo"
    } 
    else {
      if(parseFloat(substance.value) < 15){
        classe = "medio"
      } 
      else {
        if(parseFloat(substance.value) < 20){
          classe = "adequado"
        } 
        else {
            classe = "alto"
        }
      }
    }
  }

  }

  if(substanceID == 8){
    const metodoAnalise =
    store.state.dataRecomendations.reportAnalysisItems.find((reportAnalysisItem) => {
      
      return reportAnalysisItem.analysisItemId === 7;
    })

    if(metodoAnalise.value == "Água"){
      if(parseFloat(substance.value) < 5.2){
        classe = "baixo"
      } 
      else {
        if(parseFloat(substance.value) < 5.5){
          classe = "medio"
        } 
        else {
          if(parseFloat(substance.value) < 6.3){
            classe = "adequado"
          } 
          else {
              classe = "alto"
          }
        }
      }
    } 
    else {
      if(parseFloat(substance.value) < 4.5){
        classe = "baixo"
      } 
      else {
        if(parseFloat(substance.value) < 4.8){
          classe = "medio"
        } 
        else {
          if(parseFloat(substance.value) < 5.5){
            classe = "adequado"
          } 
          else {
              classe = "alto"
          }
        }
      }
    }
  }

  if(substanceID == 13){ //S(0-20)
    if(parseFloat(substance.value) < 5){
    classe = "baixo"
    } 
    else {
      if(parseFloat(substance.value) < 10){
        classe = "medio"
      } 
      else {
        if(parseFloat(substance.value) < 15){
          classe = "adequado"
        } 
        else {
            classe = "alto"
        }
      }
    }
  }

  aux = [28, 37, 29, 30, 31, 33, 64, 65, 66, 15, 16].find((id) => {return id == substanceID});

  if(aux){
    if(substanceID == 15){
      if(parseFloat(substance.value) < 30){
        classe = "baixo"
      } 
      else {
        if(parseFloat(substance.value) < 40){
          classe = "medio"
        } 
        else {
          if(parseFloat(substance.value) < 60){
            classe = "adequado"
          } 
          else {
              classe = "alto"
          }
        }
      }
    }
    if(substanceID == 16){
      if(parseFloat(substance.value) < 10){
        classe = "baixo"
      } 
      else {
        if(parseFloat(substance.value) < 13){
          classe = "medio"
        } 
        else {
          if(parseFloat(substance.value) < 20){
            classe = "adequado"
          } 
          else {
              classe = "alto"
          }
        }
      }
    }
    if(substanceID == 33){
      if(parseFloat(substance.value) < 4){
        classe = "adequado"
      } 
      else {
        if(parseFloat(substance.value) < 10){
          classe = "baixo"
        } 
        else {
          if(parseFloat(substance.value) < 20){
            classe = "medio"
          } 
          else {
              classe = "alto"
          }
        }
      }
    }
    if(substanceID == 29 || substanceID == 64){
      if(parseFloat(substance.value) < 30){
        classe = "baixo"
      } 
      else {
        if(parseFloat(substance.value) < 40){
          classe = "medio"
        } 
        else {
          if(parseFloat(substance.value) < 60){
            classe = "adequado"
          } 
          else {
              classe = "alto"
          }
        }
      }
    }
    if(substanceID == 30 || substanceID == 65){
      if(parseFloat(substance.value) < 10){
        classe = "baixo"
      } 
      else {
        if(parseFloat(substance.value) < 13){
          classe = "medio"
        } 
        else {
          if(parseFloat(substance.value) < 20){
            classe = "adequado"
          } 
          else {
              classe = "alto"
          }
        }
      }
    }
    if(substanceID == 31 || substanceID == 66){
      if(parseFloat(substance.value) < 2){
        classe = "baixo"
      } 
      else {
        if(parseFloat(substance.value) < 3){
          classe = "medio"
        } 
        else {
          if(parseFloat(substance.value) < 5){
            classe = "adequado"
          } 
          else {
              classe = "alto"
          }
        }
      }
    }
    if(substanceID == 28 || substanceID == 37){
      if(parseFloat(substance.value) < 30){
        classe = "baixo"
      } 
      else {
        if(parseFloat(substance.value) < 50){
          classe = "medio"
        } 
        else {
          if(parseFloat(substance.value) < 70){
            classe = "adequado"
          } 
          else {
              classe = "alto"
          }
        }
      }
    }
  }

  

  return classe;
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_btn, {
          label: "Gerar PDF",
          color: "primary",
          onClick: printDocument
        })
      ])
    ]),
    _createVNode(_unref(Vue3Html2pdf), {
      "show-layout": false,
      "float-layout": true,
      "enable-download": true,
      "preview-modal": false,
      "html-to-pdf-options": _unref(optionsPDF),
      "pdf-quality": 2,
      "manual-pagination": true,
      "paginate-elements-by-height": 3000,
      "pdf-format": "a4",
      "pdf-orientation": "portrait",
      "pdf-content-width": "700px",
      ref_key: "html2Pdf",
      ref: html2Pdf
    }, {
      "pdf-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_unref(reportInfo))
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                _createElementVNode("li", null, [
                  _hoisted_6,
                  _createTextVNode(": " + _toDisplayString(_unref(reportInfo).farmer), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_7,
                  _createTextVNode(": " + _toDisplayString(_unref(reportInfo).city), 1)
                ]),
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("li", null, [
                  _hoisted_10,
                  _createTextVNode(": " + _toDisplayString(_unref(reportInfo).field), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_11,
                  _createTextVNode(": " + _toDisplayString(_unref(reportInfo).area) + " ha", 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_12,
                  _createTextVNode(": " + _toDisplayString(_unref(reportInfo).report.created_at.split("T")[0].split("-")[2]) + "/ " + _toDisplayString(_unref(reportInfo).report.created_at.split("T")[0].split("-")[1]) + "/ " + _toDisplayString(_unref(reportInfo).report.created_at.split("T")[0].split("-")[0]), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_13,
                  _createTextVNode(": " + _toDisplayString(_unref(reportInfo).user), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_14,
                  _createTextVNode(": " + _toDisplayString(_unref(reportInfo).crop.name), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(store).state.dataRecomendations.reportAnalysisItems)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diagnosticoID), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "data-item",
                    key: item
                  }, [
                    _createElementVNode("h3", _hoisted_19, _toDisplayString(getItemFromAnalysis(item).analysisItem.text) + "(" + _toDisplayString(getItemFromAnalysis(item).analysisItem.unit) + ") ", 1),
                    _createElementVNode("p", {
                      class: _normalizeClass('data-item-text data-item-value ' + getClassBackground(item))
                    }, _toDisplayString(parseFloat(getItemFromAnalysis(item).value).toFixed(2)), 3)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).state.dataRecomendations.reportAnalysisItems)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(antesCorrecaoID), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "data-item",
                    key: item
                  }, [
                    _createElementVNode("h3", _hoisted_23, [
                      _createTextVNode(_toDisplayString(getItemFromAnalysis(item).analysisItem.text) + " ", 1),
                      (getItemFromAnalysis(item).analysisItem.id != 28)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (" + _toDisplayString(getItemFromAnalysis(item).analysisItem.unit) + ") ", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", {
                      class: _normalizeClass('data-item-text data-item-value ' + getClassBackground(item))
                    }, _toDisplayString(parseFloat(getItemFromAnalysis(item).value).toFixed(2)), 3)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).state.dataRecomendations.reportAnalysisItems)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(posCorrecaoID), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "data-item",
                    key: item
                  }, [
                    _createElementVNode("h3", _hoisted_27, [
                      _createTextVNode(_toDisplayString(getItemFromAnalysis(item).analysisItem.text) + " ", 1),
                      (getItemFromAnalysis(item).analysisItem.id != 37)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (" + _toDisplayString(getItemFromAnalysis(item).analysisItem.unit) + ") ", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", {
                      class: _normalizeClass('data-item-text data-item-value ' + getClassBackground(item))
                    }, _toDisplayString(parseFloat(getItemFromAnalysis(item).value).toFixed(2)), 3)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fosfatagem), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "rec-correcao-item",
              key: item
            }, [
              (item == 38)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("strong", null, _toDisplayString(getItemFromAnalysis(item).analysisItem.text) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(getItemFromAnalysis(item).value), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("strong", null, _toDisplayString(getItemFromAnalysis(item).analysisItem.text) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(parseFloat(getItemFromAnalysis(item).value).toFixed(2)), 1)
                  ], 64))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(potassagem), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "rec-correcao-item",
              key: item
            }, [
              (item == 38)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("strong", null, _toDisplayString(getItemFromAnalysis(item).analysisItem.text) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(getItemFromAnalysis(item).value), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("strong", null, _toDisplayString(getItemFromAnalysis(item).analysisItem.text) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(parseFloat(getItemFromAnalysis(item).value).toFixed(2)), 1)
                  ], 64))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _hoisted_35,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recomendacaoSoloCalagemID), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "rec-correcao-item",
              key: item
            }, [
              (item == 38)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("strong", null, _toDisplayString(getItemFromAnalysis(item).analysisItem.text) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(getItemFromAnalysis(item).value), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("strong", null, _toDisplayString(getItemFromAnalysis(item).analysisItem.text) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(parseFloat(getItemFromAnalysis(item).value).toFixed(2)), 1)
                  ], 64))
            ]))
          }), 128)),
          _hoisted_36,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recomendacaoSoloEnxofreID), (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: "item" }, [
              _hoisted_37,
              _createTextVNode(" " + _toDisplayString(getItemFromAnalysis(item).value) + " " + _toDisplayString(getItemFromAnalysis(item).analysisItem.unit), 1)
            ], 64))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.substancesApplied, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
              _createElementVNode("h6", _hoisted_40, _toDisplayString(item.thisTablesTitle), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applied, (applied) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "items-applied",
                  key: applied,
                  style: {"margin-bottom":"10px","display":"flex"}
                }, [
                  _createElementVNode("div", null, [
                    _hoisted_41,
                    _createTextVNode(" " + _toDisplayString(applied.name), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_42,
                    _createTextVNode(" " + _toDisplayString(applied.dose) + " Kg/ha", 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_43,
                    _createTextVNode(" " + _toDisplayString(applied.application), 1)
                  ])
                ]))
              }), 128)),
              _hoisted_44
            ], 64))
          }), 128))
        ]),
        _hoisted_45,
        _hoisted_46,
        _createElementVNode("div", _hoisted_47, [
          _createVNode(_component_apexchart, {
            height: "400px",
            type: "bar",
            options: _unref(optionsMicro),
            series: _unref(seriesMicro)
          }, null, 8, ["options", "series"])
        ]),
        (_unref(store).state.dataResults.microSubstancesString?.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_48, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_49,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microSubstancesString, (substance, substanceIndex) => {
                    return (_openBlock(), _createElementBlock("th", { key: substanceIndex }, _toDisplayString(substance), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_50,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microExtraction, (substance, substanceIndex) => {
                    return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_51,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microExportation, (substance, substanceIndex) => {
                    return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_52,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microSoilContents, (substance, substanceIndex) => {
                    return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", _hoisted_53, [
                  _hoisted_54,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microRecomendations, (substance, substanceIndex) => {
                    return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_55,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microNortoxAppliedValues, (microApplied, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microApplied), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_56,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microBalance, (microBalance, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microBalance), 1))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_57,
        _hoisted_58,
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_apexchart, {
            height: "400px",
            type: "bar",
            options: _unref(optionsMacro),
            series: _unref(seriesMacro)
          }, null, 8, ["options", "series"])
        ]),
        _createElementVNode("table", _hoisted_60, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_61,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroSubstancesString, (substance, substanceIndex) => {
                return (_openBlock(), _createElementBlock("th", { key: substanceIndex }, _toDisplayString(substance), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_62,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroExtraction, (substance, substanceIndex) => {
                return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_63,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroExportation, (substance, substanceIndex) => {
                return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_64,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroSoilContents, (substance, substanceIndex) => {
                return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
              }), 128))
            ]),
            _createElementVNode("tr", _hoisted_65, [
              _hoisted_66,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroRecomendations, (substance, substanceIndex) => {
                return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_67,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroNortoxAppliedValues, (microApplied, index) => {
                return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microApplied), 1))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_68,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroBalance, (microBalance, index) => {
                return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microBalance), 1))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["html-to-pdf-options"])
  ], 64))
}
}

})